import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ToolBarNotificationsService {
    private _notificationsUpdated = new Subject<void>();
    public notificationsUpdated$ = this._notificationsUpdated.asObservable();
    public notificaciones = { noRead: 0 };
    toolBarNotificationsService: any;
    // updateNotifications: any;
    

    constructor(private http: HttpClient) { }

    public getNotificationsCampana(){
        return this.http.get(`${environment.BACKEND}notificacion/campanaAlerts`);
    }

    public resetUnreadNotificationsCount(): void {
        this.notificaciones.noRead = 0;
        this._notificationsUpdated.next(null);
    }

}
